import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/globals.css";

// Always start at top on page load/refresh
if (window.location.hash) {
  history.replaceState(null, '', window.location.pathname);
}
window.scrollTo(0, 0);

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
